import backofficeService from '../../api/backoffice'

export default {

  getAll(params) {
    return backofficeService.Api().get('crm/api/store/list', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Get location profile
   * @param {*} params Query Options
   */
  getbyId(id, params = {}) {
    return backofficeService.Api().get(`crm/api/stores/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getStatus(storeID, serviceID, params = {}) {
    return backofficeService.Api().get(`crm/api/stores/getStatus/${storeID}/${serviceID}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSignUp(params) {
    return backofficeService.Api().get('crm/api/signup/getAll', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getLastInvoice(id) {
    return backofficeService.Api().get(`cspApi/getInvoice/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getSaleAlert(id) {
    
    return backofficeService.Api().get(`cspApi/getSaleAlert/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getbyCspID(cspId, params = {}) {
    return backofficeService.Api().get(`api/store/${cspId}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getStatusByCspID(cspId, params = {}) {
    return backofficeService.Api().get(`api/store/${cspId}/status`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllTicketByUser(id, params = {}) {
    return backofficeService.Api().get(`api/tickets/ticketCountByUser/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllTicketByStatus(id, params = {}) {
    return backofficeService.Api().get(`api/tickets/ticketCountByState/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  searchInStores(params = {}) {
    return backofficeService.Api().get('api/searchInStores', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  giveSoftwareUpdate(id) {
    return backofficeService.Api().get(`api/giveUpdate/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getServiceProduct(id, params = {}) {
    return backofficeService.Api().get(`api/allServiceProduct/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  setupPin(id, data) {
    return backofficeService.Api().put(`api/organizations/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  createDatabase(id) {
    return backofficeService.Api().post(`crm/api/store/createDatabase/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  removeService(id) {
    return backofficeService.Api().delete(`crm/api/store/removeService/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  addService(id, data) {
    return backofficeService.Api().post(`crm/api/addService/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  sendPassword(data) {
    return backofficeService.Api().post('api/sendPasswordEmail', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  sendPaymentUpdateLink(data) {
    return backofficeService.Api().post('api/sendPaymentUpdateLink', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  deleteCard(data) {
    return backofficeService.Api().post('api/stripe/deleteCard', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  addLocation(id, data) {
    return backofficeService.Api().post(`crm/api/store/add/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  switchCard(data) {
    return backofficeService.Api().post('api/stripe/changeDefaultCard', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  generateTempPassword(id, data) {
    return backofficeService.Api().post(`api/organizations/createTempPassword/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getAllStoreByOrg(id, params = {}) {
    return backofficeService.Api().get(`crm/api/stores/byOrganization/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getFeedbackCount(id, params = {}) {
    return backofficeService.Api().get(`noToken/ticketsCount/store/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getPromotionDeliveredByStoreID(id) {
    return backofficeService.Api().get(`cspApi/sms/getPromotionDeliveredByStoreID/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCardByStore(id) {
    return backofficeService.Api().get(`api/stripe/cards/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  updateStore(id, data) {
    return backofficeService.Api().put(`api/stores/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  askForPayment(id, data) {
    console.log(id, data)
    return backofficeService.Api().post(`api/store/askPayment/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  updateProductRelation(storeID, serviceID, data) {
    return backofficeService.Api().put(`crm/api/update/productRelation/${storeID}/${serviceID}`, data)
      .then(response => {
        return response.data
      })
      .catch((error) => { throw error })
  },
  updateModule(id, data) {
    return backofficeService.Api().put(`api/module/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
